import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['patientId', 'startsAt']

  connect() {
    if (this.data.get('reminder-sent') === 'true') {
      this.data.set('patient_id_was', this.patientIdTarget.value)
      this.data.set('starts_at_was', this.startsAtTarget.value)
    }
  }

  showAlert(e) {
    if (this.data.get('reminder-sent') === 'true') {
      if ((this.data.get('patient_id_was') !== this.patientIdTarget.value) || this.data.get('starts_at_was') !== this.startsAtTarget.value) {
        e.preventDefault()
        self = this

        swal({
          title: 'Já foi enviado o lembrete desse agendamento',
          text: 'Tem certeza que deseja alterá-lo?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
        }).then(function (result) {
          if (result.value) {
            Rails.fire(self.element, 'submit');
          }
        })
      }
    }
  }
}
